// useDownloadZip.ts
import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface DownloadZipArgs {
  keys: string[] // S3 keys (e.g., "organizations/org-id/notes/file.pdf")
  zipName?: string
}

export const useDownloadZip = () => {
  return useMutation({
    mutationFn: async ({ keys, zipName = 'attachments.zip' }: DownloadZipArgs) => {
      const response = await axios.post<{ url: string }>(`${baseUrl}/aws/s3/download-zip`, {
        keys,
        zipName,
      })
      return response.data.url
    },
  })
}
